/**
 * Angular imports.
 */
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { PipesModule } from '../pipes/pipes.module';

/**
 * Component imports.
 */
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';

/**
 * Module imports.
 */
import { MultiselectDdlModule } from '../onboarding/multiselect-ddl/multiselect-ddl.module';

@NgModule({
  declarations: [
    DynamicFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MultiselectDdlModule,
    PipesModule
  ],
  exports: [
    DynamicFormComponent
  ]
})
export class DynamicFormModule { }
